<template>
  <div id="gold">
    <HomeHeader></HomeHeader>
    <router-view></router-view>
    <HomeFooter></HomeFooter>
  </div>
</template>

<script>
// @ is an alias to /src
import HomeHeader from "@/views/home/home_header.vue";
import Homepage from "@/views/home/homepage.vue";
import HomeFooter from "@/views/home/home_footer.vue";

export default {
  name: "gold",
  components: {
    HomeHeader,
    Homepage,
    HomeFooter
  }
};
</script>

<style lang="scss">
@media print {
  .HomeHeader.noprint {
    display: none;
  }
  .footer.noprint {
    display: none;
  }
}
#gold {
  text-align: center;
  background: url(../images/background@2x.jpg);
}
#gold > *:nth-child(2) {
  min-height: calc(100vh - 377px);
}
</style>
